/**
 * getThread の WebSocket transport フレームと、その結合。
 *
 * 会話履歴は API Gateway WebSocket の 1 フレーム 128KB 上限を超えることがあるため、サーバーは
 * `done: true` のフレームまで分割して push する。これは transport の都合であり thread の domain
 * model ではないので、`models/index.ts` からは export しない（ThreadMessages が公開 model）。
 *
 * 結合をここに置くのは transport 層に業務結合をさせないため。`sendAndReceiveMany` は受信フレームを
 * そのまま返し、socket の lifecycle は結合処理の例外から独立している。
 */

import type { ThreadMessage, ThreadMessages } from './thread';

export interface ThreadMessagesFrame extends Omit<ThreadMessages, 'messages'> {
  readonly messages?: readonly ThreadMessage[];
  /** 分割対応前のサーバーからは届かないため optional。undefined は「このフレームで完了」。 */
  readonly done?: boolean;
}

/** 完了判定。`done` を送らない旧サーバーでは最初のフレームで完了として扱う。 */
export function isThreadMessagesComplete(frame: ThreadMessagesFrame): boolean {
  return frame.done !== false;
}

/** 受信順のフレームを 1 つの履歴に結合する。順序は WebSocket の受信順がそのまま履歴順。 */
export function mergeThreadMessagesFrames(frames: readonly ThreadMessagesFrame[]): ThreadMessages {
  const last = frames.at(-1);
  return {
    threadId: last?.threadId ?? '',
    expired: last?.expired ?? false,
    messages: frames.flatMap((frame) => frame.messages ?? []),
  };
}
